// TODO: This file belongs in app, not common.

import { DialogType } from '@tableau/widgets';

import { AboutTableauServerDialog } from '../../app/header/AboutTableauServerDialog';
import { GettingStartedNotifications } from '../../ts/services/GettingStartedNotifications';
import { HelpService } from '../../ts/services/HelpService';
import { ModalInstance, ReactModalService } from '../../ts/services/ReactModalService';
import { ServerService } from '../../ts/services/ServerService';

export class HelpActions {

  constructor(private help: HelpService,
              private server: ServerService,
              private gettingStartedNotifications: GettingStartedNotifications,
  ) {}

  public showAbout() {
    let modalInstance: ModalInstance;

    const dialogProps = {
      dismiss: () => modalInstance && modalInstance.dismiss(),
      serverName: this.server.serverName(),
      version: this.server.sessionServerVersion(),
      podId: this.server.sessionServerPodId()
    };

    modalInstance = ReactModalService.open({
      type: DialogType.NormalWithTitleBar,
      title: AboutTableauServerDialog.Title(dialogProps),
      dialogContent: AboutTableauServerDialog.Content(dialogProps),
      footerContent: AboutTableauServerDialog.Footer(dialogProps),
      dialogWidth: 450
    });
  }

  public showGettingStarted() {
    this.gettingStartedNotifications.forceShowNotifications();
  }

  public searchHelp(searchTerm: string) {
    this.help.search(searchTerm);
  }

}
